import type { Error } from '../types';
import { NIF_REGEX } from '../utils/regex';

export const validateNIF =
  (incorrectFormatMessage?: Error['message'], uniqueMessage?: Error['message']) =>
  (value: string): Error => {
    if (!value || value.length === 0 || !NIF_REGEX.test(value)) {
      return {
        valid: false,
        message: incorrectFormatMessage
      };
    }

    if (!['1', '2', '3'].includes(value[0])) {
      return {
        valid: false,
        message: uniqueMessage
      };
    }

    return { valid: true };
  };
